var DATE_FORMAT = 'dd/MM/yyyy';
var TIME_FORMAT = 'hh:mm:ss';
var FULL_DATE_TIME_FORMAT = DATE_FORMAT + ' ' + TIME_FORMAT;
export default {
  DATE_FORMAT: DATE_FORMAT,
  TIME_FORMAT: TIME_FORMAT,
  FULL_DATE_TIME_FORMAT: FULL_DATE_TIME_FORMAT
};